/**
 * TreeManager class handles tree operations including finding nodes and updating the tree
 */
class TreeManager {
  /**
   * Find a node by id in the tree
   * @param {Array} nodes - Array of tree nodes
   * @param {string} id - Node id to find
   * @returns {Object|null} - Found node or null
   */
  findNodeById(nodes, id) {
    for (const node of nodes) {
      if (node.id === id) return node;
      if (node.children) {
        const found = this.findNodeById(node.children, id);
        if (found) return found;
      }
    }
    return null;
  }

  /**
   * Handle tree update
   * @param {Array} tree - New tree structure
   * @param {string} currentFolderId - Current folder ID
   * @returns {Object} - Object with updated rootTree and shouldInitializeFolder flag
   */
  handleTreeUpdate(tree, currentFolderId) {
    // Return flag to indicate if we should initialize currentFolderId
    const shouldInitializeFolder = tree.length > 0 && currentFolderId === '';
    return {
      rootTree: tree,
      shouldInitializeFolder
    };
  }

  /**
   * Count total nodes in the tree including nested children
   * @param {Array} nodes - Array of tree nodes
   * @returns {number} - Total count of nodes
   */
  countNodes(nodes) {
    let count = 0;
    for (const node of nodes) {
      count++;
      if (node.children) {
        count += this.countNodes(node.children);
      }
    }
    return count;
  }

  /**
   * Get the maximum depth of the tree
   * @param {Array} nodes - Array of tree nodes
   * @param {number} currentDepth - Current depth level
   * @returns {number} - Maximum depth of the tree
   */
  getMaxDepth(nodes, currentDepth = 0) {
    if (!nodes || nodes.length === 0) {
      return currentDepth;
    }
    let maxDepth = currentDepth + 1;
    for (const node of nodes) {
      if (node.children) {
        const childDepth = this.getMaxDepth(node.children, currentDepth + 1);
        maxDepth = Math.max(maxDepth, childDepth);
      }
    }
    return maxDepth;
  }
}

export default TreeManager;
